import { issueInvoicePageViewList } from "pages/IssueInvoice/utils";

export const ERROR_CONNECT_TOOL_USB =
  "Lỗi kết nối. Vui lòng kiểm tra lại file kết nối và ấn restart lại";
export const ERROR_GET_INFO_USB =
  "Không lấy dc thông tin USB token. Vui lòng kiểm tra lại USB và ấn Recheck";
export const GET_INFO_USB = "Đang lấy thông tin USB token";

export const ISSUE_INVOICE_COMMON_FIELD = {
  PBAN: {
    field: "pban", // Phiên Bản
    type: "text",
    max: 6,
    disabled: true,
    isHide: true,
    required: false,
  },
  TTCHUNG_KHHDON: {
    field: "ttchung_khhdon", // Ký hiệu hóa đơn
    type: "text",
    isKHHD: true,
    max: 6,
    required: true,
  },
  TTCHUNG_HTTTOAN: {
    field: "ttchung_htttoan", // Hình thức thanh toán
    type: "select",
    max: 50,
    required: false,
  },
  TTCHUNG_KHMSHDON: {
    field: "ttchung_khmshdon", // Ký hiệu mẫu số hóa đơn
    type: "select",
    selectValues: {
      VAT_INVOICE: "1",
      SALE_INVOICE: "2",
      TICKETS_INVOICE: "5",
    },
    max: 1,
    required: false,
    disabled: true,
  },
  TTCHUNG_MHSO: {
    field: "ttchung_mhso", // Mã hồ sơ
    type: "text",
    max: 20,
    required: false,
  },
  TTCHUNG_SHDON: {
    field: "ttchung_shdon", // Số hóa đơn
    type: "text",
    required: false,
    disabled: true,
  },
  TTCHUNG_SBKE: {
    field: "ttchung_sbke", // Số bảng kê
    type: "text",
    max: 20,
    required: false,
  },
  TTCHUNG_NLAP: {
    field: "ttchung_nlap", // Ngày lập
    type: "date",
    required: false,
    disabled: true,
  },
  TTCHUNG_NBKE: {
    field: "ttchung_nbke", // Ngày bảng kê
    type: "date",
    required: false,
  },
  TTCHUNG_DVTTE: {
    field: "ttchung_dvtte", // Đơn vị tiền tệ
    type: "select",
    max: 3,
    required: true,
  },
  TTCHUNG_TGIA: {
    field: "ttchung_tgia", // Tỷ giá
    type: "number",
    max: 7,
    disabled: true,
    required: false,
  },
  TTCHUNG_THDON: {
    field: "ttchung_thdon", // Tên Hóa Đơn
    type: "text",
    isHide: true,
    max: 100,
    required: false,
  },
  TTCHUNG_MSTTCGP: {
    field: "ttchung_msttcgp", // Mã số thuế tổ chức cung cấp giải pháp hóa đơn điện tử
    type: "text",
    isHide: true,
    max: 14,
    required: false,
  },
  TTCHUNG_MSTDVNUNLHDON: {
    field: "ttchung_mstdvnunlhdon", // Mã số thuế đơn vị nhận ủy nhiệm lập hóa đơn
    type: "text",
    max: 14,
    isHide: true,
    required: false,
  },
  TTCHUNG_TDVNUNLHDON: {
    field: "ttchung_tdvnunlhdon", // Tên đơn vị nhận ủy nhiệm lập hóa đơn
    type: "text",
    max: 400,
    required: false,
    isHide: true,
  },
  TTCHUNG_DCDVNUNLHDON: {
    field: "ttchung_dcdvnunlhdon", // Địa chỉ đơn vị nhận ủy nhiệm lập hóa đơn
    type: "text",
    max: 400,
    isHide: true,
    required: false,
  },
  TTCHUNG_HDDCKPTQUAN: {
    // chỉ với HD BH,
    field: "ttchung_hddckptquan", // Hoá đơn dành cho khu phi thuế quan
    type: "select",
    isHide: true,
    isShowWithPageView: [
      issueInvoicePageViewList.PAGE_SALE_INVOICE_HAVE_CODE,
      issueInvoicePageViewList.PAGE_SALE_INVOICE_NONE_CODE,
    ],
    selectValues: {
      VAT_INVOICE: "1",
      SALE_INVOICE: "2",
    },
    max: 1,
    required: false,
  },
  TTChung_TTKhac: {
    field: "ttchung_ttkhac", // Thông tin chung khác
    type: "text",
    max: 255,
    isHide: true,
    required: false,
  },
};

export const ISSUE_INVOICE_SELLER_FIELD = {
  NBAN_TEN: {
    field: "nban_ten", // Tên
    type: "text",
    max: 400,
    disabled: true,
    required: false,
  },
  NBAN_MST: {
    field: "nban_mst", // Mã số thuế
    type: "text",
    isTaxCode: true,
    max: 14,
    disabled: true,
    required: false,
  },
  NBAN_DCHI: {
    field: "nban_dchi", // Địa chỉ
    type: "text",
    max: 400,
    disabled: true,
    required: false,
  },
  NBAN_SDTHOAI: {
    field: "nban_sdthoai", // Số điện thoại
    type: "text",
    disabled: true,
    required: false,
    max: 20,
  },
  NBAN_DCTDTU: {
    field: "nban_dctdtu", // Địa chỉ thư điện tử
    type: "text",
    max: 50,
    disabled: true,
    required: false,
  },
  NBAN_STKNHANG: {
    field: "nban_stknhang", // Số tài khoản ngân hàng
    type: "text",
    max: 30,
    disabled: true,
    required: false,
  },
  NBAN_TNHANG: {
    field: "nban_tnhang", // Tên ngân hàng
    type: "text",
    max: 400,
    disabled: true,
    required: false,
  },
  NBAN_FAX: {
    field: "nban_fax", // Fax
    type: "text",
    max: 20,
    disabled: true,
    required: false,
  },
  NBAN_WEBSITE: {
    field: "nban_website", // Website
    type: "text",
    max: 100,
    disabled: true,
    required: false,
  },
  NBAN_TTKHAC: {
    field: "nban_ttkhac", // Thông tin khác
    type: "text",
    isHide: true,
    max: 255,
    disabled: true,
    required: false,
  },
};

export const ISSUE_INVOICE_BUYER_FIELD = {
  NMUA_TEN: {
    field: "nmua_ten", // Tên người mua hàng
    type: "text",
    max: 400,
    required: true,
  },
  NMUA_MST: {
    field: "nmua_mst", // Mã số thuế
    isTaxCode: true,
    type: "text",
    max: 14,
  },
  NMUA_DCHI: {
    field: "nmua_dchi", // Địa chỉ
    type: "text",
    max: 400,
  },
  NMUA_MKHANG: {
    field: "nmua_mkhang", // Mã khách hàng
    type: "text",
    max: 50,
  },
  NMUA_SDTHOAI: {
    field: "nmua_sdthoai", // Số điện thoại
    type: "text",
    max: 20,
  },
  NMUA_DCTDTU: {
    field: "nmua_dctdtu", // Địa chỉ thư điện tử
    type: "text",
    isEmail: true,
    max: 50,
  },

  NMUA_HVTNMHANG: {
    field: "nmua_hvtnmhang", // Họ và tên người mua hàng
    type: "text",
    max: 100,
  },
  SEND_MAIL: {
    field: "send_mail", // Địa chỉ thư điện tử
    type: "checkbox",
    isEmail: true,
    max: 50,
  },
  NMUA_STKNHANG: {
    field: "nmua_stknhang", // Số tài khoản ngân hàng
    type: "text",
    max: 30,
  },
  NMUA_TNHANG: {
    field: "nmua_tnhang", // Tên ngân hàng
    type: "text",
    max: 400,
  },
  NMua_TTKhac: {
    field: "nmua_ttkhac", // Thông tin khác
    type: "text",
    max: 255,
    isHide: true,
    require: false,
  },
};

// Danh sách hàng hóa dịch vụ
export const ISSUE_INVOICE_HHDV_FIELD = {
  HHDV_OBJ: {
    field: "hhdv_obj",
    type: "field_array",
    fieldReal: "listInvoiceDetail",
    list: {
      TCHAT: {
        field: "tchat", // Tính chất
        fieldReal: "tchat",
        type: "select",
        selectValues: {
          GOODS: "1", // hàng hóa dịch vụ
          PROMOTION: "2", // khuyến mãi
          DISCOUNT: "3", // chiết khấu thương mại
          EXPLAIN: "4", // Ghi chú diễn giải
        },
        max: 1,
        width: "350px",
        required: true,
      },
      STT: {
        field: "stt", // Số thứ tự
        fieldReal: "stt",
        type: "number",
        isHide: true,
        required: false,
        max: 4,
      },
      MHHDVU: {
        field: "mhhdvu", // Mã hàng hóa, dịch vụ
        fieldReal: "mhhdvu",
        type: "select",
        max: 50,
        width: "200px",
        allowCreate: true,
        required: false,
      },
      THHDVU: {
        field: "thhdvu", // Tên hàng hóa, dịch vụ, diễn giải
        fieldReal: "thhdvu",
        // type: "text",
        max: 500,
        width: "300px",
        type: "select",
        allowCreate: true,
        required: true,
      },
      DVTINH: {
        field: "dvtinh", // Đơn vị tính
        fieldReal: "dvtinh",
        type: "text",
        max: 50,
        width: "300px",
        required: false,
      },
      SLUONG: {
        field: "sluong", // Số lượng
        fieldReal: "sluong",
        type: "number",
        width: "200px",
        isThousandSeparator: true,
        max: 21,
        required: false,
      },
      DGIA: {
        field: "dgia", // Đơn giá
        fieldReal: "dgia",
        type: "number",
        width: "200px",
        isThousandSeparator: true,
        max: 21,
        required: false,
      },
      TLCKHAU: {
        field: "tlckhau", // Tỷ lệ % chiết khấu
        fieldReal: "tlckhau",
        type: "number",
        isThousandSeparator: true,
        width: "200px",
        maxValue: 100,
        required: false,
      },
      STCKHAU: {
        field: "stckhau", // Số tiền chiết khấu
        fieldReal: "stckhau",
        type: "number",
        isThousandSeparator: true,
        width: "200px",
        max: 21,
        required: false,
      },
      TSUAT: {
        field: "tsuat", // Thuế suất
        fieldReal: "tsuat",
        type: "select",
        width: "200px",
        allowCreate: true,
        isShowWithPageView: [
          issueInvoicePageViewList.PAGE_VAT_INVOICE_HAVE_CODE,
          issueInvoicePageViewList.PAGE_VAT_INVOICE_NONE_CODE,
          issueInvoicePageViewList.PAGE_INVOICE_TICKETS_HAVE_CODE,
          issueInvoicePageViewList.PAGE_INVOICE_TICKETS_NONE_CODE,
        ],
        max: 11,
        required: false,
      },
      THTIEN: {
        field: "thtien", // Thành tiền
        fieldReal: "thtien",
        width: "300px",
        type: "number",
        isThousandSeparator: true,
        max: 21,
        disabled: true,
        required: false,
      },
      TTKHAC: {
        field: "ttkhac", // Thông tin khác
        fieldReal: "ttkhac",
        type: "text",
        isHide: true,
        required: false,
        max: 255,
      },
    },
  },
};

export const ISSUE_INVOICE_PAYMENT_FIELD = {
  TTOAN_LTSUAT_OBJ: {
    field: "ttoan_ltsuat_obj",
    fieldReal: "ttoan_ltsuat",
    type: "field_array",
    list: {
      TSUAT: {
        field: "ttoan_tsuat", // Thuế suất thuế GTGT
        fieldReal: "TSuat",
        type: "select",
        width: "200px",
        max: 11,
        disabled: true,
        allowNegative: true,
        required: false,
      },
      THTIEN: {
        field: "ttoan_thtien", // Thành tiền chưa có thuế GTGT
        fieldReal: "ThTien",
        type: "number",
        isThousandSeparator: true,
        max: 21,
        disabled: true,
        allowNegative: true,
        required: false,
      },
      TTHUE: {
        field: "ttoan_tthue", // Tiền thuế GTGT
        fieldReal: "TThue",
        type: "number",
        isThousandSeparator: true,
        allowNegative: true,
        disabled: true,
        required: false,
        max: 21,
      },
    },
  },
  TTOAN_TGTCTHUE: {
    field: "ttoan_tgtcthue", // Tổng tiền chưa thuế
    type: "number",
    isThousandSeparator: true,
    allowNegative: true,
    max: 21,
    widthLabel: "266px",
    disabled: true,
    required: false,
    isHide: false,
    isShowWithPageView: [
      issueInvoicePageViewList.PAGE_VAT_INVOICE_HAVE_CODE,
      issueInvoicePageViewList.PAGE_VAT_INVOICE_NONE_CODE,
      issueInvoicePageViewList.PAGE_INVOICE_TICKETS_HAVE_CODE,
      issueInvoicePageViewList.PAGE_INVOICE_TICKETS_NONE_CODE,
    ],
  },
  TTOAN_TGTTHUE: {
    field: "ttoan_tgtthue", // Tổng tiền thuế
    type: "number",
    allowNegative: true,
    max: 21,
    isThousandSeparator: true,
    isHide: false,
    isShowWithPageView: [
      issueInvoicePageViewList.PAGE_VAT_INVOICE_HAVE_CODE,
      issueInvoicePageViewList.PAGE_VAT_INVOICE_NONE_CODE,
      issueInvoicePageViewList.PAGE_INVOICE_TICKETS_HAVE_CODE,
      issueInvoicePageViewList.PAGE_INVOICE_TICKETS_NONE_CODE,
    ],
    disabled: true,
    widthLabel: "266px",
    required: false,
  },
  //   TTOAN_LPHI_OBJ: {
  //     field: "ttoan_lphi_obj",
  //     fieldReal: "ttoan_lphi",
  //     type: "field_array",
  //     list: {
  //       TLPHI: {
  //         field: "ttoan_tlphi", // Tên loại phí
  //         fieldReal: "TLPhi",
  //         type: "text",
  //         max: 100,
  //       },
  //       TPHI: {
  //         field: "ttoan_tphi", // Tiền thuế
  //         fieldReal: "TPhi",
  //         type: "number",
  //         max: 21,
  //       },
  //     },
  //   },
  TTOAN_TTCKTMAI: {
    field: "ttoan_ttcktmai", // Tổng tiền chiết khấu thương mại
    type: "number",
    isThousandSeparator: true,
    allowNegative: true,
    disabled: true,
    widthLabel: "266px",
    required: false,
    max: 21,
  },
  TTOAN_TGTTTBSO: {
    field: "ttoan_tgtttbso", // Tổng tiền thanh toán bằng số
    type: "number",
    isThousandSeparator: true,
    allowNegative: true,
    disabled: true,
    widthLabel: "266px",
    max: 21,
    required: false,
  },
  TTOAN_TGTTTBCHU: {
    field: "ttoan_tgtttbchu", // Tổng tiền thanh toán bằng chữ
    type: "text",
    disabled: true,
    widthLabel: "266px",
    max: 255,
    required: false,
  },
  TTOAN_TTKHAC_OBJ: {
    field: "ttoan_ttkhac", // Thanh toán khác
    type: "text",
    isHide: true,
    max: 255,
    required: false,
  },
};

export const TYPE_INVOICE_ANOTHER = {
  INVOICE_TICKETS: "INVOICE_TICKETS",
  DELIVERY_BILL: "DELIVERY_BILL",
  WAREHOUSE_AGENCY: "WAREHOUSE_AGENCY",
  INVOICE_TOTAL: "INVOICE_TOTAL",
};

export const MODE_INVOICE_ACTION = {
  REPLACE: "REPLACE",
  ADJUST: "ADJUST",
};

export const TYPE_ADJUST_INVOICE = {
  INCREASE: 1,
  DECREASE: 2,
  CHANGE_INFO: 3,
};

export const TYPE_REPORT_WORD = {
  ADJUST: "adjust",
  CANCEL: "cancel",
  INFO: "info",
};

export const TYPE_ACTION_WORKFLOW = {
  SUBMIT: "SUBMIT",
  APPROVE: "APPROVE",
  REJECT: "REJECT",
};
